import AnalyticsView from "../../../features/supervision/analytics/components/AnalyticsView/AnalyticsView";
import { useLocation } from 'react-router-dom';
import { PageTable, Header } from '/src/layouts/page/index';
import AnalyticsContextProvider from "../../../features/supervision/analytics/context/AnalyticsContext";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import storage from "/src/utils/storage";
import ModalManager from "@ebay/nice-modal-react";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import analyticService from "/src/features/supervision/analytics/services/analyticService";
import { useAnalyticsStateContext } from "../../../features/supervision/analytics/context/AnalyticsContext";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import { useState } from "react";

function AnalyticsDeleteForm({ firstPeriod, periodChoice, channels }) {
    var text = '';
    if(periodChoice === 'custom') text = 'since ' + firstPeriod.date_start + " to " + firstPeriod.date_end
    else if (periodChoice !== 'all') text = `since last ${periodChoice}`;
    text += ' for one of the following channel(s) ?'

    return (
        <>
        <div>Do you really want to delete all analytics {text}</div>
        <div style={{ padding : "0 100px"}}>
            {channels.map((channel, index) => {
                return (
                    <div style={{ display : 'flex', flexDirection : 'row', paddingTop : 10}}>
                        <span className={channel.value.length == '32' ? 'fas fa-globe' : 'fas fa-phone'} style={{ fontSize : 27, color : 'var(--main)'}}/>
                        <div style={{ paddingLeft : 10, display : 'flex', alignItems : 'center', fontSize : '16px', color : 'var(--dark)'}}>{channel.value} </div>
                    </div>
                )
            })}
        </div>
        </>
    )
}

function AnalyticsPageContent() {

    const location = useLocation();
    var name = location.pathname.split('/').pop();
    const { is_admin } = storage('local').get('user');

    const { deleteAll } = analyticService;
    const { periodChoice, firstPeriod, channels } = useAnalyticsStateContext();

    const deleteAction = async () => {

        const body = {...firstPeriod}
        ModalManager.show(ApiModal, {
            title : 'Delete Analytics ' + name,
            body : <AnalyticsDeleteForm periodChoice={periodChoice} firstPeriod={firstPeriod} channels={channels}/>,
            api : {
                request : deleteAll,
                param : [name, body]
            },
            buttons : [
                {className : 'cancel', label : 'Cancel'},
                {className : 'validate', label : 'Yes', type : 'submit'},
            ],
            confirm : {
                name: channels,
                fieldName: "the channel",
            }
        }).then(() => window.location.reload())
    }

    return (
        <>
            <Header title={"Analytics " + name}>
                { is_admin && channels.length ? <IconButton className={'error-iconButton delete_action main_add-button space_tableButton'} icon='fas fa-trash' onClick={deleteAction} /> : null }
            </Header>
            <AnalyticsView name={name}/>
        </>
    )
}

function AnalyticsPage() {
    return (
        <PageTable>
            <AnalyticsContextProvider>
                <AnalyticsPageContent/>
            </AnalyticsContextProvider>
        </PageTable>
    ) 
}

export default AnalyticsPage;